export default "__VITE_ASSET__Bm8S8WWk__"